<style lang="less" scoped>
@import './confirm.less';
.mbox-border {
  .maddress {
    margin-top: 10px;
    padding: 8px 15px;
    background-color: #fff;
    position: relative;
    padding-right: 50px;
    .maddress-item {
      line-height: 28px;
      color: #555;
    }
    .maddress-btn {
      position: absolute;
      right: 25px;
      top: 25px;
    }
    .maddree-empty {
      padding: 16px 0;
      color: #93979a;
    }
  }
  .mgoods {
    margin-top: 10px;
    background-color: #fff;
    padding: 10px 10px 0 10px;
    .mgoods-item {
      display: flex;
      justify-content: space-around;
      padding: 10px;
      border-bottom: 1px solid #eee;
      .item-left {
        img {
          width: 120px;
          height: 120px;
        }
      }
      .item-right {
        padding-left: 15px;
        &-title {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          color: #555555;
        }
        &-price {
          font-size: 16px;
          color: #a30014;
          padding: 10px 0px;
        }
        &-num {
          color: #555555;
        }
      }
    }
    .mgoods-item:last-child {
      border: none;
    }
  }
  .minvoice {
    margin-top: 10px;
  }
  .mprice {
    margin-top: 10px;
  }
  .mpay {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 60px;
    width: 100vw;
    box-shadow: 0px -1px 5px rgba(170, 170, 170, 0.35);
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .mpay-btn {
      width: 120px;
      height: 36px;
      background-color: #409eff;
      color: #ffffff;
      text-align: center;
      line-height: 36px;
      border-radius: 5px;
    }
  }
  .address-input {
    width: 100%;
    height: 50px;
    align-items: center;
    background: white;
    display: flex;
    /deep/.el-input__inner {
      border: none !important;
      border-radius: 0;
      padding: 0;
      margin: 0;
    }
    input {
      border: none !important;
    }
  }
  .agreement {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 60px;
    display: flex;
    align-items: center;
    background: #efefef;
    height: 37px;
    .pointer {
      cursor: pointer;
    }
    &__icon {
      width: 27px;
      height: 27px;
      margin: 0 2px 0 13px;
    }
    &__link {
      color: #409eff;
    }
  }
}
</style>
<template>
  <div style="margin:0 auto;overflow-x:auto;">
    <div class="mbox-border">
      <div style="padding: 8px 15px;text-align: center;margin-top: 10px;background: #ffffff">
        <div class="pointer" style="color: #409eff;text-align: center"  @click="onToAgreement">《卡西欧隐私权政策》</div>
      </div>
      <div v-if="activity.region && activity.address" class="flex col" style="background:white;padding: 0 20px;color:#999">
        <div class="address-input solid-bottom">{{ activity.region }}{{ activity.address }}</div>
        <el-input class="address-input solid-bottom" placeholder="请输入收货人信息" v-model="consigneeValue" />
        <el-input class="address-input" placeholder="请输入收货人手机号码" type="number" v-model="mobileValue" />
      </div>
      <div class="maddress" v-else>
        <div v-if="address&&address.length" style="margin-right:40px;">
          <div class="maddress-item">
            <span>{{addressInfo.consignee}}</span>
            <span>{{addressInfo.mobile}}</span>
          </div>
          <div class="maddress-item">{{addressInfo.region}} {{addressInfo.address}}</div>
        </div>
        <div class="maddree-empty" v-else @click="editAddress">请选择收获地址</div>
        <div class="maddress-btn" @click="editAddress">编辑</div>
      </div>
      <div class="mgoods" v-if="tableData&&tableData.length">
        <div class="mgoods-item" v-for="(item, index) in tableData" :key="index">
          <div class="item-left">
            <img :src="item.image" alt="">
          </div>
          <div class="item-right">
            <div class="item-right-title">{{item.productName}}</div>
            <div class="item-right-price">{{item.salePrice | price}}</div>
            <div class="item-right-num">数量 x{{item.number}}</div>
          </div>
        </div>
      </div>
      <div class="minvoice">
        <van-field v-if="this.activity.invoiceForbidden" label="发票信息 :" value="个人 电子发票" readonly input-align="right" />
        <van-field v-else label="发票信息 :" :value="`${invoiceTypeText} 电子发票`" is-link readonly input-align="right" @click="showInvoice=true" />
        <van-field v-if="invoiceType === 2" v-model="invoiceName" label="单位名称" placeholder="请输入单位名称" input-align="right" />
        <van-field v-if="invoiceType === 2" v-model="invoiceNo" label="税号" placeholder="请输入税号" input-align="right" />
        <van-field label="支付方式 :" :value="payMethodText" is-link readonly input-align="right" @click="showPayMethod=true" />
      </div>
      <div class="mprice">
        <van-field label="商品总价 :" :value="formatPrice(totalPrice)" readonly input-align="right" />
        <van-field label="运费 :" :value="formatPrice(plusFee)" readonly input-align="right" />
        <van-field label="优惠 :" :value="`-${formatPrice(cartInfo.discountAmount||0)}`" readonly input-align="right" />
      </div>
      <div class="mpay">
        <div>应付金额: <span style="color: #A30014">{{formatPrice(cartInfo.orderAmount)}}</span></div>
        <div class="mpay-btn" @click="submitOrder">提交订单</div>
      </div>
      <div style="height: 97px"></div>
    </div>
    <van-popup v-model="showInvoice" position="bottom">
      <van-picker title="" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showInvoice=false" />
    </van-popup>
    <van-popup v-model="showPayMethod" position="bottom">
      <van-picker title="" show-toolbar :columns="payColumns" @confirm="onPayConfirm" @cancel="showPayMethod=false" />
    </van-popup>
    <!--收货信息开始-->
    <!-- <div class="box-border" style="margin-top:0;">
      <p class="head-title">收货信息</p>
      <div class="address-box">
        <ul>
          <li>
            <div class="left fl">
              <svg-icon class="address-location" icon-class="address" style="font-size:31px;"/>
            </div>
            <div class="right" style="line-height:30px;">
              <el-radio-group v-model="addOrder.shippingType" >
                <el-radio :label="item.value" v-for="item in $enums.shippingType.getList()">{{item.label}}</el-radio>
              </el-radio-group>
            </div>
          </li>

          <li style="margin-bottom:0;" v-if="(addOrder.shippingType == this.$enums.shippingType.EXPRESS)">
            <div class="left fl">
              <span class="key-name">收货地址</span>
            </div>
            <div class="right fl">
              <el-radio-group v-model="addressId" v-for="item in address" @change="getAddressInfo">
                <el-radio :label="item.id" class="address-content">
                    <span class="address-info">{{item.consignee}}</span>
                    <span class="address-info">{{item.region}} {{item.address}}</span>
                    <span class="address-info">{{item.mobile}}</span>
                </el-radio>
              </el-radio-group>
            </div>
          </li>

          <li v-if="(addOrder.shippingType == this.$enums.shippingType.EXPRESS)">
            <div class="left fl">&nbsp;</div>
            <div class="right">
              <el-button type="info" @click="dialogFormVisible = true" plain style="border-radius:0;">新增地址</el-button>
            </div>
          </li>
        </ul>
      </div>
    </div> -->
    <!--收货信息结束-->

    <!--新增收货地址弹窗-->
    <!-- <el-dialog title="新增收货地址" :visible.sync="dialogFormVisible">
      <div id="addAddress">
        <div class="left fl">
          <el-form :rules="rules" :model="addAddress" ref="form">
          <ul>
            <li>
              <span class="key fl">所在地区：</span>
              <div class="area fl" style="width: 500px;">
                  <el-form-item prop="region">
                    <el-cascader style="width: 440px;" size="large" :options="options" v-model="regionOptions" @change="handleChange" ref="region"></el-cascader>
                  </el-form-item>
              </div>
            </li>

            <li>
              <span class="key fl">详细地址：</span>
              <div class="area-detail fl">
                <el-form-item prop="address">
                <el-input style="width: 440px;" resize="none" type="textarea" :rows="3" placeholder="请输入详细地址信息，如街道、小区、门牌号等信息" v-model="addAddress.address"></el-input>
                </el-form-item>
              </div>
            </li>

            <li style="margin-bottom: 0px;">
              <span class="key fl" style="letter-spacing: 4px;">收货人：</span>
              <div class="consign fl" >
                <el-form-item prop="consignee">
                <el-input style="width: 160px;" placeholder="请输入姓名" v-model="addAddress.consignee"></el-input>

                </el-form-item>
              </div>

              <span class="key fl">手机号码：</span>
              <div class="consign fl">
                 <el-form-item prop="mobile">
                   <el-input style="width: 160px;" placeholder="请输入11手机号码" v-model="addAddress.mobile"></el-input>
                 </el-form-item>
              </div>
            </li>

          </ul>
          </el-form>
        </div>
        <div class="right fl">
          <p class="set-default">
            <el-checkbox-group v-model="addAddress.isDefault">
              <el-checkbox label="1" style="font-size: 14px;">设为默认</el-checkbox>
            </el-checkbox-group>
          </p>
          <p class="submit">
            <span class="primary" @click="saveAddress">保存地址</span>
          </p>
        </div>
      </div>
    </el-dialog> -->
    <!--新增收货地址弹窗结束-->

    <!--支付方式开始-->
    <!-- <div class="box-border">
      <p class="head-title">支付方式</p>
      <div class="pay-type">
        <el-radio-group v-model="addOrder.payMethod">
          <el-radio :label="$enums.payments.ALIPAY_WEB"><img src="@/assets/payMethod/alipay.jpg"></el-radio>
          <el-radio :label="$enums.payments.WECHAT_SCAN"><img src="@/assets/payMethod/wechatPay.jpg"></el-radio>
        </el-radio-group>
      </div>
    </div> -->
    <!--支付方式结束-->

    <!--发票信息开始-->
    <!-- <div class="box-border">
      <p class="head-title">发票信息</p>
      <div class="invoice-info">
        <ul>
          <li>
            <span class="left">发票类型：</span>
            <span class="right">个人</span>
          </li>
          <li>
            <span class="left">发票内容：</span>
            <span class="right">产品明细</span>
          </li>
          <li>
            <p class="desc">*关于内购发票：内购默认开具个人电子发票</p>
          </li>
        </ul>
      </div>
    </div> -->
    <!--发票信息结束-->

    <!--商品清单开始-->
    <!-- <div class="product-list box-border" style="margin: 0;">
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column label="商品清单"  width="630">
          <template slot-scope="scope">
            <div class="product-name product-image">
              <img :src="scope.row.image" alt="">
            </div>
            <div class="right product-name">
              <div class="product-string">
                {{ scope.row.productName }}
              </div>
              <div class="product-string sign">
                {{$enums.productMark.label(scope.row.mark)}}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="单价" width="240">
          <template slot-scope="scope">
            <span class="price">{{ scope.row.salePrice | price }}</span>
          </template>
        </el-table-column>

        <el-table-column label="数量" >
          <template slot-scope="scope">
            <span class="number">{{scope.row.number}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div> -->

    <!-- <div class="box-border order-basic-info" v-if="false">
      <div class="top">
        <p>
          <span class="fr value" :title="totalPrice | price">{{ totalPrice | price }}</span>
          <span class="fr name">商品金额：</span>
        </p>

        <p>
          <span class="fr value">{{ cartNum }}</span>
          <span class="fr name">总件数：</span>
        </p>

        <p>
          <span class="fr value">{{ plusFee | price}}</span>
          <span class="fr name">运费：</span>
        </p>
      </div>

      <div class="bottom">
        <p>
          <span class="fr total-amount">{{ addOrder.orderAmount | price }}</span>
          <span class="fr name">应付金额：</span>
        </p>

        <p v-if="(addOrder.shippingType == this.$enums.shippingType.EXPRESS)">
          <span class="fr value">
            {{addressInfo.region}}{{addressInfo.address}}
          </span>
          <span class="fr name">快递：</span>
        </p>

        <p>
            <span class="fr pay-now" @click="submitOrder">去付款</span>
          <router-link :to="{ name: 'cart-index'}">
          <span class="fr back-cart">返回购物车</span>
          </router-link>
        </p>
      </div>

    </div> -->
    <!--商品清单结束-->

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import { formatPrice } from "@/helpers";
import { Toast } from 'vant';
import { isWechat } from '@/helpers'

export default {
  name: 'confirm',
  data() {
    const checkRegion = (_, value, callback) => {
      if (!this.addAddress.region)
        callback('请选择收货地址')
      callback()
    }
    const checkMobile = (_, value, callback) => {
      if (!this.addAddress.mobile) {
        callback('请输入手机号')
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.addAddress.mobile)) {
        callback('手机号格式不正确')
        return
      }
      callback()
    }
    return {
      formatPrice,
      consigneeValue: '',
      mobileValue: '',
      rules: {
        address: [{ required: true, message: "请输入详情地址", trigger: "blur" }],
        consignee: [
          { required: true, message: "请输入收货人信息", trigger: "blur" }
        ],
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        region: [{ validator: checkRegion, trigger: "blur" }],
      },
      addressId: null,
      addressInfo: {},
      dialogFormVisible: false,
      options: regionData,
      regionOptions: [],
      plusFee: 0,
      addAddress: {
        consignee: '',
        mobile: '',
        region: '',
        address: '',
        isDefault: 0,
        memberId: 0,
      },
      addOrder: {
        memberId: 0,
        activityId: 0,
        payMethod: this.$enums.payments.ALIPAY_WEB,
        shippingType: this.$enums.shippingType.EXPRESS,
      },
      showInvoice: false,
      showPayMethod: false,
      invoiceType: 1,
      invoiceTypeText: '个人',
      columns: [{ type: 1, text: '个人' }, { type: 2, text: '单位' }],
      invoiceName: '',
      invoiceNo: '',
    };
  },
  methods: {
    onConfirm(value) {
      this.invoiceTypeText = value.text
      this.invoiceType = value.type
      this.showInvoice = false
    },
    onPayConfirm(value) {
      this.addOrder.payMethod = value.value
      this.showPayMethod = false
    },
    editAddress() {
      this.$router.push({ name: 'member-member-address', query: { type: 'order' } })
    },
    handleChange(value) {
      this.$refs.form.clearValidate(['region'])
      if (CodeToText[value[2]]) {
        this.addAddress.region = CodeToText[value[0]] + ' ' + CodeToText[value[1]] + ' ' + CodeToText[value[2]];
      } else {
        this.addAddress.region = CodeToText[value[0]] + ' ' + CodeToText[value[1]];
      }
    },
    createOrder() {
      this.addOrder.memberId = this.memberId;
      this.addOrder.activityId = this.activityId;
      this.addOrder.productAmount = this.totalPrice * 1;
      this.addOrder.shippingAmount = this.plusFee * 1;
      this.addOrder.orderAmount = this.totalPrice * 1 + this.plusFee * 1;
    },
    getAddressInfo() {
      this.addressInfo = this.address.find((item) => {
        if (this.addressId && (item.id == this.addressId)) {
          return true;
        } else if (!this.addressId && item.isDefault == 1) {
          return true;
        } else if (!this.addressId) {
          return true;
        }
        return false;
      });
      if (!this.addressId) {
        this.addressId = this.addressInfo.id;
      }
    },
    async saveAddress() {
      this.$refs.form.validate(async (value) => {
        if (value) {
          this.addAddress.memberId = this.memberId;
          const result = await this.$store.dispatch('address/create', this.addAddress);
          this.addressId = result.document.id;
          this.getAddress();
          this.getAddressInfo();
          this.dialogFormVisible = false;
        }
      })
    },
    async getAddress() {
      await this.$store.dispatch('address/collection', { sorts: { isDefault: 'DESC' } , query: { activityId: this.activityId } , all: true  });
      if (this.address.length > 0) {
        this.getAddressInfo();
      }
    },
    async submitOrder() {
      if (this.activity.region && this.activity.address) {
        if (!this.consigneeValue) {
          this.$message.warning('请输入收货人信息')
          return
        }
        if (!this.mobileValue) {
          this.$message.warning('请输入收货人手机号码')
          return
        }
        if (!/^1[3456789]\d{9}$/.test(this.mobileValue)) {
          this.$message.warning('请输入正确的手机号码')
          return
        }
      } else if (!this.addressId) {
        Toast('请选择收货地址后再提交');
        return
      }

      if (!this.tableData.length) {
        Toast('购物车为空');
        return
      }

      if (!this.invoiceName && this.invoiceType === 2) {
        Toast('请输入单位名称');
        return
      }

      if (!this.invoiceNo && this.invoiceType === 2) {
        Toast('请输入税号');
        return
      }

      //判断收货方式
      if (this.addOrder.shippingType == this.$enums.shippingType.EXPRESS) {
        if (this.activity.region && this.activity.address) {
          this.addOrder.consignee = this.consigneeValue;
          this.addOrder.mobile = this.mobileValue;
          this.addOrder.region = this.activity.region;
          this.addOrder.address = this.activity.address;
        } else {
          this.addOrder.consignee = this.addressInfo.consignee;
          this.addOrder.mobile = this.addressInfo.mobile;
          this.addOrder.region = this.addressInfo.region;
          this.addOrder.address = this.addressInfo.address;
        }
      }
      if (this.invoiceType === 2) {
        this.addOrder.invoiceName = this.invoiceName
        this.addOrder.invoiceNo = this.invoiceNo
      }
      const orderProducts = []
      this.tableData.map(item => {
        orderProducts.push({
          activityProductId: item.activityProductId,
          discountAmount: item.discountAmount,
          image: item.image,
          mark: item.mark,
          number: item.number,
          productName: item.productName,
          productSpecId: item.productSpecId,
          realPrice: item.realPrice,
          salePrice: item.salePrice,
          sku: item.sku
        })
      })
      this.addOrder.orderProducts = orderProducts
      await this.$store.dispatch('orders/create', this.addOrder).then((result) => {
        if (result.document.id) {
          this.$store.dispatch('cart/clear');
          this.$router.push({ name: 'pay-index', params: { id: result.document.id } });
        }
      });
    },
    onToAgreement() {
      this.$router.push({ name: 'agreement' , params: { name: 'privacy' } });
    },
  },
  async mounted() {
    this.plusFee = this.activity.deliveryConfigs.express.plusFee ? this.activity.deliveryConfigs.express.plusFee : 0;
    this.addressId = this.$route.query.addressId || null
    this.getAddress();
    this.createOrder();
    if (this.activity.region && this.activity.address) {
      const data = await this.$store.dispatch('address/getConsignee')
      if (data.consignee) {
        this.consigneeValue = data.consignee
      }

      if (data.mobile) {
        this.mobileValue = data.mobile
      }
    }
  },
  computed: {
    ...mapState('cart', {
      tableData: state => state.cart,
      cartInfo: state => state.cartInfo
    }),
    ...mapState('activity', {
      activity: state => state.activity,
      activityId: state => state.activityId,
    }),
    ...mapState('address', {
      address: state => state.collection.collection,
    }),
    ...mapState('auth', {
      memberId: state => state.currentUser.id
    }),
    ...mapGetters('cart', {
      cartNum: 'cartNum',
      totalPrice: 'totalPrice',
    }),
    payMethodText() {
      return this.$enums.payments.label(this.addOrder.payMethod)
    },
    payColumns() {
      let cols =  this.$enums.payments.getList().map(item => ({ text: item.label, value: item.value }))
      //if (!isWechat()) {
      //  cols = cols.filter(item => item.value !== 'wechat-scan')
      //}
      return cols
    },
  },
};
</script>


